import { render, staticRenderFns } from "./previewBox.vue?vue&type=template&id=c8b6bfc6&scoped=true"
import script from "./previewBox.vue?vue&type=script&lang=js"
export * from "./previewBox.vue?vue&type=script&lang=js"
import style0 from "./previewBox.vue?vue&type=style&index=0&id=c8b6bfc6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b6bfc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8b6bfc6')) {
      api.createRecord('c8b6bfc6', component.options)
    } else {
      api.reload('c8b6bfc6', component.options)
    }
    module.hot.accept("./previewBox.vue?vue&type=template&id=c8b6bfc6&scoped=true", function () {
      api.rerender('c8b6bfc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/previewBox.vue"
export default component.exports